import { GEnum } from '@/constants/enum.defination';

function loadView(componentName: string) {
  return () => import(`@/views/${componentName}/${componentName}.vue`);
}

const routes = [
  {
    path: '/',
    name: 'index',
    component: loadView('GHome'),
    meta: {
      requiresAuth: true,
      template: GEnum.Template.Default,
    },
  },
  {
    path: '/signin',
    name: 'signin',
    component: loadView('GSignin'),
    meta: {
      requiresAuth: false,
      template: GEnum.Template.Default,
    },
  },
  {
    // Googleログイン後にリダイレクトされる.
    path: '/oauth/callback',
    name: 'OAuthCallback',
    component: loadView('GOAuthCallback'),
    meta: {
      requiresAuth: false,
      template: GEnum.Template.Default,
    },
  },
  {
    path: '/reset-password/step1',
    component: loadView('GResetPasswordStep1'),
    meta: {
      requiresAuth: false,
      template: GEnum.Template.Default,
    },
  },
  {
    path: '/reset-password/step2',
    component: loadView('GResetPasswordStep2'),
    meta: {
      requiresAuth: false,
      template: GEnum.Template.Default,
    },
  },
  {
    path: '/pages/home',
    name: 'home',
    component: loadView('GHome'),
    meta: {
      requiresAuth: true,
      template: GEnum.Template.Default,
    },
  },
  {
    path: '/pages/students',
    name: 'students',
    component: loadView('GStudents'),
    meta: {
      requiresAuth: true,
      template: GEnum.Template.Default,
    },
  },
  {
    path: '/pages/student-edit/:id',
    name: 'student-edit',
    component: loadView('GStudentEdit'),
    meta: {
      requiresAuth: true,
      template: GEnum.Template.Default,
    },
  },
  {
    path: '/pages/student-record/:studentID',
    name: 'student-record',
    component: loadView('GStudentRecord'),
    meta: {
      requiresAuth: true,
      template: GEnum.Template.Default,
    },
  },
  {
    path: '/pages/student-all-competency/:studentID',
    name: 'student-all-competency',
    component: loadView('GStudentAllCompetencyChart'),
    meta: {
      requiresAuth: true,
      template: GEnum.Template.Default,
    },
  },
  {
    path: '/pages/student-all-competency-growth/:studentID',
    name: 'student-all-competency-growth',
    component: loadView('GStudentAllCompetencyGrowthChart'),
    meta: {
      requiresAuth: true,
      template: GEnum.Template.Default,
    },
  },
  {
    path: '/pages/exam/list',
    name: 'exam-list',
    component: loadView('GExamList'),
    meta: {
      requiresAuth: true,
      template: GEnum.Template.Default,
    },
  },
  {
    path: '/pages/exam/create',
    name: 'exam-create',
    component: loadView('GExamCreate'),
    meta: {
      requiresAuth: true,
      template: GEnum.Template.Default,
    },
  },
  {
    path: '/pages/exam/:evalSettingID',
    name: 'exam-detail',
    component: loadView('GExamDetail'),
    meta: {
      requiresAuth: true,
      template: GEnum.Template.Default,
    },
  },
  {
    path: '/pages/exam/:evalSettingID/edit',
    name: 'exam-edit',
    component: loadView('GExamEdit'),
    meta: {
      requiresAuth: true,
      template: GEnum.Template.Default,
    },
  },
  {
    path: '/pages/class-management/',
    name: 'class-management',
    component: loadView('GClassManagement'),
    meta: {
      requiresAuth: true,
      template: GEnum.Template.Default,
    },
  },
  {
    path: '/pages/competency-ranking-details',
    name: 'competency-ranking-details',
    component: loadView('GCompetencyRankingDetails'),
    meta: {
      requiresAuth: true,
      template: GEnum.Template.Default,
    },
  },
  {
    path: '/pages/group-edit/:id',
    name: 'group-edit',
    component: loadView('GGroupEdit'),
    meta: {
      requiresAuth: true,
      template: GEnum.Template.Default,
    },
  },
  {
    path: '/pages/teachers/',
    name: 'teachers',
    component: loadView('GTeachers'),
    meta: {
      requiresAuth: true,
      template: GEnum.Template.Default,
    },
  },
  {
    path: '/pages/teachers/create',
    name: 'teacher-registration',
    component: loadView('GTeacherRegistration'),
    meta: {
      requiresAuth: true,
      template: GEnum.Template.Default,
    },
  },
  {
    path: '/pages/teacher-edit/:id',
    name: 'teacher-edit',
    component: loadView('GTeacherEdit'),
    meta: {
      requiresAuth: true,
      template: GEnum.Template.Default,
    },
  },
  {
    path: '/pages/statistics',
    name: 'statistics',
    component: loadView('GStatistics'),
    meta: {
      requiresAuth: true,
      template: GEnum.Template.Default,
    },
  },
  {
    path: '/pages/schoolClasses',
    name: 'schoolClasses',
    component: loadView('GSchoolClasses'),
    meta: {
      requiresAuth: true,
      template: GEnum.Template.Default,
    },
  },
  {
    path: '/pages/schoolClasses/change',
    name: 'schoolClassChange',
    component: loadView('GSchoolClassChange'),
    meta: {
      requiresAuth: true,
      template: GEnum.Template.Default,
    },
  },
  {
    path: '/pages/academicPromotion',
    name: 'academicPromotion',
    component: loadView('GAcademicPromotion'),
    meta: {
      requiresAuth: true,
      template: GEnum.Template.Default,
    },
  },
  {
    path: '/pages/customCompetency',
    name: 'customCompetency',
    component: loadView('GCustomCompetency'),
    meta: {
      requiresAuth: true,
      template: GEnum.Template.Default,
    },
  },
  {
    path: '/pages/customBoxplotSetting',
    name: 'customBoxplotSetting',
    component: loadView('GCustomBoxplotSetting'),
    meta: {
      requiresAuth: true,
      template: GEnum.Template.Default,
    },
  },
  {
    path: '/pages/schoolSetting',
    name: 'schoolSetting',
    component: loadView('GSchoolSetting'),
    meta: {
      requiresAuth: true,
      template: GEnum.Template.Default,
    },
  },
  {
    // JGROW - activity list
    path: '/pages/jgrow/activity',
    name: 'jgrowActivity',
    component: loadView('GJgrowActivity'),
    meta: {
      requiresAuth: true,
      template: GEnum.Template.Default,
    },
  },
  {
    // JGROW - activity create
    path: '/pages/jgrow/activity/create',
    name: 'jgrowActivityCreate',
    component: loadView('GJgrowActivityCreate'),
    meta: {
      requiresAuth: true,
      template: GEnum.Template.Default,
    },
  },
  {
    // JGROW - event list
    path: '/pages/jgrow/event',
    name: 'jgrowEvent',
    component: loadView('GJgrowEvent'),
    meta: {
      requiresAuth: true,
      template: GEnum.Template.Default,
    },
  },
  {
    // JGROW - event create
    path: '/pages/jgrow/event/create',
    name: 'jgrowEventCreate',
    component: loadView('GJgrowEventCreate'),
    meta: {
      requiresAuth: true,
      template: GEnum.Template.Default,
    },
  },
  { // JGROW - event datail
    path: '/pages/jgrow/event/:eventID',
    name: 'jgrowEventDetail',
    component: loadView('GJgrowEventDetail'),
    meta: {
      requiresAuth: true,
      template: GEnum.Template.Default,
    },
  },
  {
    path: '/pages/jgrow/analysis',
    name: 'surveyAnalyze',
    component: loadView('GSurveyAnalyze'),
    meta: {
      requiresAuth: true,
      template: GEnum.Template.Default,
    },
  },
];

export default routes;
